import request from "./request";
import apis from "./apis";

const {
  semesterInfos,
  semesterInfosByYear,
  semesterInfosById,
  semesterInfo,
  examInfo,
} = apis.semester;

const semester = {
  getSemesters: (data: Object) => {
    return request.get(semesterInfos, data);
  },
  getSemestersByYear: (data: Object) => {
    return request.get(semesterInfosByYear, data);
  },
  getSemestersById: (data: Object) => {
    return request.get(semesterInfosById, data);
  },
  createSemester: (data: Object) => {
    return request.post(semesterInfo, data);
  },
  updateSemesterAndExam: (data: Object) => {
    return request.put(semesterInfo, data);
  },
  deleteSemester: (data: Object) => {
    return request.delete(semesterInfo, data);
  },
  createExam: (data: Object) => {
    return request.post(examInfo, data);
  },
  deleteExam: (data: Object) => {
    return request.delete(examInfo, data);
  },
};

export default semester;